// Lucide icon: ban (https://lucide.dev/icons/ban)
import { Ban } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconDisable = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Ban />
    </IconComponentStyled>
  )
}
